import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// A Kundli generated before sign-up lives only in localStorage. Once the visitor
// has an account, attach it so it is saved, emailed and listed on the dashboard.
export async function claimLocalReport() {
  let local = null;
  try { local = JSON.parse(localStorage.getItem("astrofate_report") || "null"); } catch { return null; }
  if (!local?.chart || local.report_id || local.id) return local;
  try {
    const res = await axios.post(`${API}/kundli/claim`, {
      name: local.birth_details?.name || local.name || "Kundli",
      birth_details: local.birth_details || {},
      report: local.report || "",
      chart: local.chart,
      lang: local.lang || "en",
    }, { withCredentials: true });
    const merged = { ...local, report_id: res.data.report_id };
    localStorage.setItem("astrofate_report", JSON.stringify(merged));
    return merged;
  } catch {
    return local;
  }
}

export const signupUrl = (redirect) => `/auth?tab=signup&redirect=${encodeURIComponent(redirect)}`;
